import React, { useContext, useEffect, useState } from 'react';
// Contexts
import { SIGAMContext } from '~/contexts/SIGAMContext';
// Own Components
import Header from './components/Header';
import Content from './components/Content';
// Components
import Loading from '~/components/loading';
import UpdatePendingCard from '~/pages/SIGAM/components/Cards/UpdatePendingCard';
// Utils
import SocialMeAPI from '~/utils/SocialMeAPI';

export default function Users() {
  const { activeInstitution } = useContext(SIGAMContext);
  const [loadingContent, setLoadingContent] = useState(true);
  const [searchInput, setSearchInput] = useState();
  const [users, setUsers] = useState([]);
  const [pageParameters, setPageParameters] = useState({
    currentPage: 1,
    totalElements: 0,
    limit: 10,
  });
  const [updatePending, setUpdatePending] = useState(false);

  async function GetDataAgain(newPageParameters) {
    setLoadingContent(true);
    const params = {
      operation: ['SIGAM', 'Users', 'Get'],
      urlParams: {
        institutionId: activeInstitution.id,
      },
      data: {
        filter: {
          searchString: searchInput,
        },
        pagination: {
          limit: newPageParameters
            ? newPageParameters.limit
            : pageParameters.limit,
          page: newPageParameters
            ? newPageParameters.currentPage
            : pageParameters.currentPage,
          sort: {
            by: 'id',
            order: 'asc',
          },
        },
      },
    };
    const response = await SocialMeAPI(params);
    if (response.success) {
      setUpdatePending(false);
      setPageParameters({
        ...pageParameters,
        currentPage: response.body.peopleList.currentPage,
        totalElements: response.body.peopleList.totalElements,
        limit: response.body.peopleList.limit,
      });
      setUsers(response.body.peopleList.elements);
      setLoadingContent(false);
    }
  }

  useEffect(() => {
    async function GetUsers() {
      const params = {
        operation: ['SIGAM', 'Users', 'Get'],
        urlParams: {
          institutionId: activeInstitution.id,
        },
        data: {
          filter: {
            search_string: searchInput,
          },
          pagination: {
            sort: {
              by: 'id',
              order: 'asc',
            },
          },
        },
      };
      const response = await SocialMeAPI(params);
      if (response.success) {
        setPageParameters({
          currentPage: response.body.peopleList.currentPage,
          totalElements: response.body.peopleList.totalElements,
          limit: response.body.peopleList.limit,
        });
        setUsers(response.body.peopleList.elements);
      }
      setLoadingContent(false);
    }
    GetUsers();
  }, [activeInstitution, searchInput]);

  return (
    <div>
      <Header
        setSearchInput={setSearchInput}
        setUpdatePending={setUpdatePending}
      />
      {loadingContent ? (
        <Loading text="Buscando Usuários" />
      ) : (
        <>
          <UpdatePendingCard
            GetDataAgain={GetDataAgain}
            updatePending={updatePending}
          />
          <Content
            data={users}
            pageParameters={pageParameters}
            GetDataAgain={GetDataAgain}
            setUpdatePending={setUpdatePending}
          />
        </>
      )}
    </div>
  );
}
